export default "__VITE_ASSET__6fac51b4__"